module.exports = __webpack_public_path__ + "static/img/3.b124234.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/default/upload/commonality/20240725/3.jpg
// module id = xTsa
// module chunks = 7